// Func = limiting Scope for this file
var lastScrollTop = 0;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;

let darkArrow = '';
let lightArrow = '';
let controlArrow = '';
let initialDot = '';
let hoverDot = '';

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function getImageDimensions(url) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			resolve({ width: img.width, height: img.height });
		};
		img.onerror = (err) => {
			reject('Error loading image');
		};
		img.src = url;
	});
}

function responsiveTablet(){
	document.querySelectorAll('.js-responsive-tablet').forEach( element => {
		if(windowWidth < 1000){
			if(!element.classList.contains('changed')){
				element.classList.add('changed');
				element.src = element.dataset.tablet;
			}
		} else {
			if(element.classList.contains('changed')){
				element.classList.remove('changed');
				element.src = element.dataset.desktop;
			}
		}
	})
	
}

function resizeWindow(){
	windowWidth = window.innerWidth;
	windowHeight = window.innerHeight;


	responsiveTablet();
	

	if(windowWidth < 600){
		//responsive image:
		if(document.querySelectorAll('.js-responsive-img').length > 0){
			document.querySelectorAll('.js-responsive-img').forEach( img => {
				if(!img.classList.contains('changed')){
					img.classList.add('changed');
					img.src = img.dataset.mobile;
				}
			})
		}
	} else {
		//responsive image:
		 if(document.querySelectorAll('.js-responsive-img').length > 0){
			document.querySelectorAll('.js-responsive-img').forEach( img => {
				if(img.classList.contains('changed')){
					img.classList.remove('changed');
					img.src = img.dataset.desktop;
				}
			})
		}
	}
}

function formSubmit(className) {
    const submitButtons = document.querySelectorAll('button[type="submit"]');
    if (!submitButtons.length) return;

    const rootStyle = getComputedStyle(document.documentElement);
    const effectClass = rootStyle.getPropertyValue(`--sym-components-ctas-${className}-effect-hover`).trim();

    submitButtons.forEach(submit => {
        submit.classList.add('btn', `btn-${className}`);

        if (!submit.querySelector('.deco')) {
            submit.innerHTML = `<span class="${`deco ${effectClass}`.trim()}"></span><span class="label">${submit.innerHTML}</span>`;
        }
    });
}

function resetFilter(className) {
	const resetButton = document.querySelectorAll('.btn[data-title="reset filter"]');
    if (!resetButton.length) return;
    const rootStyle = getComputedStyle(document.documentElement);
    const effectClass = rootStyle.getPropertyValue(`--sym-components-ctas-${className}-effect-hover`).trim();

    resetButton.forEach(btn => {
        btn.classList.add('btn', `btn-${className}`);
		console.log(btn);
        if (!btn.querySelector('.deco')) {
            btn.innerHTML = `<span class="${`deco ${effectClass}`.trim()}"></span><span class="label">${btn.innerHTML}</span>`;
        }
    });
}



function addArrows() {
	if(document.querySelectorAll('.js-plus-arrow').length > 0){
        
        document.querySelectorAll('.js-plus-arrow').forEach( arrow => {
			if (arrow.querySelector('img')) {
                return; 
            }
            let currentIcon = arrow.dataset.arrow;
            let arrowImg = document.createElement('img');
            let match = null; 

            switch (currentIcon) {
                case 'arrow_dark':
                    match = darkArrow ? darkArrow.match(/url\("?(.+?)"?\)/) : null;
                    break;
                case 'arrow_light':
                    match = lightArrow ? lightArrow.match(/url\("?(.+?)"?\)/) : null;
                    break;
                case 'arrow_imgs':
                    match = controlArrow ? controlArrow.match(/url\("?(.+?)"?\)/) : null;
                    break;
                 default:
                    match = darkArrow ? darkArrow.match(/url\("?(.+?)"?\)/) : null;
            }
            if (match && match[1]) {
                arrowImg.src = match[1];
                arrow.appendChild(arrowImg);
            }
        })
    }
}

function RootVariables(){

	let effectConfig = {
		'primary': '--sym-components-ctas-primary-effect-hover',
		'secondary': '--sym-components-ctas-secondary-effect-hover',
		'tertiary': '--sym-components-ctas-tertiary-effect-hover',
	};

	let foundEffects = {};
	let allRoots = document.querySelectorAll(':root');

	allRoots.forEach(root => {
		let stylesVariables = getComputedStyle(root);

		//Cta effect
		for (const [key, variable] of Object.entries(effectConfig)) {
			let value = stylesVariables.getPropertyValue(variable).trim();
			if (value) {
				foundEffects[key] = value;
			}
		}

		for (const [type, className] of Object.entries(foundEffects)) {
			let btns = document.querySelectorAll(`.btn-${type}`);
			btns.forEach(btn => {
				let span = btn.querySelector('span');
				if (span) {
					span.classList.add(className);
				}
				
			});
		}

		// Arrows & Dots 
		darkArrow = stylesVariables.getPropertyValue('--sym-icons-arrow-dark').trim();
		lightArrow = stylesVariables.getPropertyValue('--sym-icons-arrow-light').trim() != 'none' ? stylesVariables.getPropertyValue('--sym-icons-arrow-light').trim() : darkArrow;
		controlArrow = stylesVariables.getPropertyValue('--sym-icons-arrow-alt').trim() != 'none' ? stylesVariables.getPropertyValue('--sym-icons-arrow-alt').trim() : lightArrow;
		addArrows();

		//Form submit add class
		formSubmit(stylesVariables.getPropertyValue('--sym-components-forms-cta-style').trim());
		
		//Reset Filter add class
		resetFilter(stylesVariables.getPropertyValue('--sym-components-filters-reset-style').trim());

		// Filter effects
		if(document.querySelectorAll('.js-filter-tabs').length > 0){
			document.querySelectorAll('.js-filter-tabs').forEach( tabs => {
				tabs.classList.add(`${stylesVariables.getPropertyValue('--sym-components-filters-effect-hover').trim()}-effect`);
			})
		}

		//Sub nav effects 
		if(document.querySelectorAll('.js-nav').length > 0){
			document.querySelectorAll('.js-nav').forEach( tabs => {
				tabs.classList.add(`${stylesVariables.getPropertyValue('--sym-components-subnav-effect-hover').trim()}-effect`);
			})
		}
		//Lightbox
		if(document.querySelectorAll('.sym-lightbox').length > 0 ){
			const lightboxArray = document.querySelectorAll('.sym-lightbox');
			lightboxArray.forEach((lightbox) => {
				let titleLightbox = lightbox.querySelector('.sym-lightbox--title');
				let titleStyle = stylesVariables.getPropertyValue('--sym-components-modal-title-style').trim();

				if (titleLightbox) {
					 titleLightbox.classList.add(`sym-${titleStyle}`);
				}

				let subtitleLightbox = lightbox.querySelector('.sym-lightbox--subtitle');
				if(subtitleLightbox){
					let subtitleStyle = stylesVariables.getPropertyValue('--sym-components-modal-subtitle-style').trim();
					subtitleLightbox.classList.add(`sym-${subtitleStyle}`);
				}
			});
		}


	});	
	
}

(function(){

	RootVariables();
	window.addEventListener('resize', function() {
        resizeWindow();
	});
	resizeWindow();

	//track view menu
	document.querySelectorAll('a').forEach( link => {
		if(!link.dataset.section){
			if(link.textContent.toLowerCase().indexOf('menu') > -1){
				link.dataset.section = 'track-menu'
			}
		}
	})


	//LBX CUSTOM
	LBX._instances[0].icons.close = `<span class="lightbox--close"></span>`;
	LBX._instances[0].icons.next = `<span class="lightbox--next"></span>`;
	LBX._instances[0].icons.prev = `<span class="lightbox--prev"></span>`;

	

	const customLightbox = new LBX('.js-lightbox--gallery', {
		icons:{
			close:`<span class="lightbox-gallery--close"></span>`,
			next:`<span class="lightbox-gallery--next"></span>`,
			prev:`<span class="lightbox-gallery--prev"></span>`,
		}
	});

	const customLightboxFull = new LBX('.js-lightbox--gallery-full-screen', {
		icons:{
			close:`<span class="lightbox-gallery--close"></span>`,
			next:`<span class="lightbox-gallery--next"></span>`,
			prev:`<span class="lightbox-gallery--prev"></span>`,
		},
		fullScreen:true
	});

	const lightboxVideo = new LBX('.js-lightbox-video', {
		icons:{
			close:`<span class="lightbox--close"></span>`,
		},
		beforeShow:() =>{
			const video_lbx = document.querySelector('.lbx_item figure video')
			if (video_lbx){
				video_lbx.load();
				video_lbx.addEventListener('loadeddata',  () => {
					video_lbx.play();
				});
			}
		}
	});


	const customLightboxVideo = new LBX('.interactive-video-lbx', {
		icons:{
			close:`<span class="lightbox--close"></span>`,
		},
		beforeShow:() =>{
			const video_lightbox = document.querySelectorAll('.interactive-video__lightbox figure video')
			if (video_lightbox){
				video_lightbox.forEach(video => {
					video.load();
					video.addEventListener('loadeddata',  () => {
						video.play();
					});
				});
			}
		}
	});

	if(document.querySelectorAll('.btn').length > 0){
		document.querySelectorAll('.btn').forEach( btn => {
			if(btn.querySelector('span') === null){
				let span = document.createElement('span');
				span.innerHTML = btn.innerHTML;
				btn.innerHTML = '';
				btn.appendChild(span);
			}
		})
	}

	//cms form focus animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}
	if(document.querySelectorAll('.field').length > 0){
		document.querySelectorAll('.field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	document.addEventListener('click', (e) => {
		const cta = e.target.closest('[data-go]');
		if (!cta || !cta.hash) return;
		if (cta.pathname !== window.location.pathname || cta.host !== window.location.host) return;

		const target = decodeURIComponent(cta.hash.substring(1));
		if (!document.getElementById(target)) {
			return;
		}

		e.preventDefault();
		animateTo(target);
		history.pushState(null, '', cta.hash);
	});

	document.addEventListener('click', (e) => {
		const cta = e.target.closest('a[data-lbx]');
		if (!cta) return;

		if (cta.classList.contains('js-btn-menu')) return;

		const id = decodeURIComponent((cta.getAttribute('href') || '').replace(/^#/, ''));
		const containers = ['.lightbox', '.sym-lightbox'];
		const selector = containers
			.map(c => `${c}[id="${id}"], ${c} [id="${id}"]`)
			.join(', ');

		if (!id || !document.querySelector(selector)) {
			e.preventDefault();
			e.stopImmediatePropagation();
			console.warn(`[CTA] No existe un lightbox con id "${id}"`);
		}
	}, true);



	function initHashScroll() {
		if (!window.location.hash) return;
		requestAnimationFrame(() => animateTo(window.location.hash.substring(1)));
	}
	if (document.readyState === 'complete') {
		initHashScroll();
	} else {
		window.addEventListener('load', initHashScroll);
	}


	//SCROLL TO ANIMATION
	window.location.hash && animateTo(window.location.hash.substring(1));
	document.querySelectorAll('[data-go]').forEach(cta => {
		let target = cta.hash.substring(1);
		if (!document.getElementById(target))
			return;
		cta.addEventListener("click", (e) => {
			e.preventDefault();
			animateTo(target);
		});
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//GO SECTION SIMPLE LINKS
	function normalizeGoLinks(root = document) {
		root.querySelectorAll('a[href^="go="]').forEach(a => {
			a.setAttribute('href', a.getAttribute('href').replace(/^go=/i, '').trim());
			a.setAttribute('data-go', '');
		});
	}
	
	normalizeGoLinks();
	addTrackingClass();
})();


function getHeaderOffset() {
	const header = document.getElementById('header') || document.getElementsByTagName('header')[0];
	if (!header) return 0;
	const r = header.getBoundingClientRect();
	return r.height + r.top;
}

function animateTo(target) {
	const id = decodeURIComponent(target);
	const toTarget = document.getElementById(id);
	if (!toTarget) return;

	const from = window.scrollY;
	const duration = 1400;
	let start = null;
	let cancelled = false;

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

	const cancel = () => { cancelled = true; };
	window.addEventListener('wheel', cancel, { passive: true, once: true });
	window.addEventListener('touchstart', cancel, { passive: true, once: true });

	function step(timestamp) {
		if (cancelled) return;
		if (start === null) start = timestamp;

		const progress = Math.min((timestamp - start) / duration, 1);
		const to = toTarget.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

		window.scrollTo(0, easeInOutQuart(progress) * (to - from) + from);

		if (progress < 1) requestAnimationFrame(step);
	}

	requestAnimationFrame(step);
}

function addTrackingClass(){
	const allLinks = document.querySelectorAll('a');
	const allButtons = document.querySelectorAll('button');
	allLinks.forEach(link =>{
		if(link.href.includes('mailto:'))link.classList.add('track-email');
		if(link.href.includes('tel:'))link.classList.add('track-phone');
		if(link.href.includes('https://www.google.com/maps/'))link.classList.add('track-address');
		if(link.textContent.toLowerCase().includes('view floor plan'))link.classList.add('track-floorplan')
		validationText(link);
	})
	allButtons.forEach(link =>{
		validationText(link);
	})
}

function validationText(link){
	let arrayText = link.textContent.toLowerCase().split(' ');
	arrayText.forEach(text=>{
		if((text.includes('order') && text.includes('online')) || text.includes('order'))link.classList.add('track-order');
		if(text.includes('gift')||text.includes('card'))link.classList.add('track-gift');
		if(text.includes('spa')||text.includes('menu'))link.classList.add('track-menu');
		if(text.includes('book')&&!text.includes('facebook'))link.classList.add('book-now');
	})
}

// Accessibility: Focus on Main Content when using "Skip to Content"
const skipLink = document.querySelector('.skip-to-content');
const mainContent = document.getElementById('intro-content');

if (skipLink && mainContent) {
    skipLink.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();

            mainContent.setAttribute('tabindex', '-1');
			mainContent.focus();
        }
    });
}


